import slice from './slice';

export { createResource, buildPayload } from './resources';
export const { reducer } = slice;
